import { FC, memo } from 'react';
import { triggerTracking } from '@zoopla/tracking';
import { ButtonLinkLeft } from '@zoopla-eng/zds/button';
import { PinFilledSmall } from '@zoopla-eng/zds/icons';

type mapIconProps = {
    href: string;
};

const MAP_VIEW_TEXT = 'Map view';

export const MapIcon: FC<React.PropsWithChildren<mapIconProps>> = memo(
    ({ href }) => {
        return (
            <ButtonLinkLeft
                category="tertiary"
                href={href}
                data-testid="map-view-link"
                rel={'nofollow'}
                onClick={() =>
                    triggerTracking({
                        event: 'GAEvent',
                        eventCategory: 'search results',
                        eventAction: 'clickthrough',
                        eventLabel: 'view_type_map'
                    })
                }
                Icon={PinFilledSmall}
            >
                {MAP_VIEW_TEXT}
            </ButtonLinkLeft>
        );
    }
);

MapIcon.displayName = 'MapIconComponent';
